import { render, staticRenderFns } from "./filter-rooms.vue?vue&type=template&id=63f1b6c8"
import script from "./filter-rooms.vue?vue&type=script&lang=js"
export * from "./filter-rooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports